/* eslint-disable react/jsx-key */
import { Box, Button, Flex, Image, Text, VStack, useBreakpoint } from "@chakra-ui/react";
import { useRouter } from "next/router";
import type { ComponentProps } from "react";
import React from "react";
import { MediumBreak, SmallBreak } from "../helpers";

const FreeCoachingSection = () => {
  const breakpoint = useBreakpoint();

  return (
    <Box gap="64px" bgColor="#0D3050" py={{ lg: "100px", base: "64px" }}>
      <Flex
        mx="auto"
        px={{ xl: "160px", lg: "24px", base: "16px" }}
        gap={{ xl: "64px", lg: "54px", base: "40px" }}
        direction={{ xl: "row", lg: "column", base: "column" }}
        maxWidth={"1440px"}
      >
        <CardDetail />
        <Image
          src={
            breakpoint === "xl" || breakpoint === "2xl"
              ? "/images/free-coaching/thumbnail.webp"
              : breakpoint === "lg"
              ? "/images/free-coaching/thumbnail1.webp"
              : "/images/free-coaching/mobile-thumbnail.jpg"
          }
          alt="free-coaching-thumbnail"
          w={{ xl: "512px", lg: "full" }}
        />
      </Flex>
    </Box>
  );
};

const CardDetail = () => {
  const router = useRouter();
  const coaching = [
    <React.Fragment>
      Discover your goal outcomes with the help of our expert coaches.
    </React.Fragment>,
    <React.Fragment>
      Create a plan of action to <SmallBreak /> achieve your goals with <SmallBreak /> guidance and
      support.
    </React.Fragment>,
    <React.Fragment>
      Receive a personalized report of your coaching assessments and action plans, <MediumBreak />
      three days after your&nbsp;sessions.
    </React.Fragment>,
  ];
  return (
    <VStack align="start" justify={"center"} color="white" fontFamily="'Inter', sans-serif">
      <Text
        fontFamily={"Georgia"}
        fontSize={{ lg: "56px", base: "32px" }}
        lineHeight={{ lg: " 64px", base: "36px" }}
        mb="16px"
      >
        Free Coaching!
      </Text>
      <Text
        fontSize={{ lg: "20px", base: "18px" }}
        lineHeight={{ lg: " 32px", base: "28px" }}
        pb="24px"
      >
        Book a no-cost trial coaching session with experienced coaches to identify where you are in
        your career journey today and close the gap on where you’d like to be. By the end of the two
        coaching sessions, you will:
      </Text>
      <Flex gap="16px" pb={"24px"} direction={"column"}>
        {coaching.map((data, idx) => {
          return (
            <Flex key={idx} gap="12px" align={"start"}>
              <Box mt="5px">
                <CheckIcon width="28px" height="28px" />
              </Box>
              <Text
                fontSize={{ lg: "20px", base: "18px" }}
                lineHeight={{ lg: " 32px", base: "28px" }}
              >
                {data}
              </Text>
            </Flex>
          );
        })}
      </Flex>
      <Text
        fontSize={{ lg: "20px", base: "18px" }}
        lineHeight={{ lg: " 32px", base: "28px" }}
        pb={{ lg: "40px", base: "32px" }}
      >
        👋 Secure your spot today - Limited spaces available.
      </Text>
      <Flex w="full">
        <Button
          bgColor={"#F9D209"}
          size="lg"
          w={{ base: "full", lg: "unset" }}
          px={"25px"}
          h={{ base: "44px", lg: "48px" }}
          onClick={() => {
            router.push("/campaign");
          }}
        >
          Find Out More
        </Button>
      </Flex>
    </VStack>
  );
};
export default FreeCoachingSection;
export function CheckIcon(props: ComponentProps<"svg">) {
  return (
    <svg
      width="28"
      height="29"
      viewBox="0 0 28 29"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M19.9458 9.08165L11.5925 17.1433L9.3758 14.775C8.96747 14.39 8.3258 14.3667 7.85913 14.6933C7.40413 15.0317 7.2758 15.6267 7.5558 16.105L10.1808 20.375C10.4375 20.7717 10.8808 21.0167 11.3825 21.0167C11.8608 21.0167 12.3158 20.7717 12.5725 20.375C12.9925 19.8267 21.0075 10.2717 21.0075 10.2717C22.0575 9.19832 20.7858 8.25332 19.9458 9.06998V9.08165Z"
        fill="#F9D209"
      />
    </svg>
  );
}
